import { useEffect, useState } from "react";
import axios from "axios";
import { BarChart3, Eye, CalendarDays } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const svDate = (iso) =>
  new Date(iso + "T12:00:00").toLocaleDateString("sv-SE", { weekday: "short", day: "numeric", month: "short" });

export default function StatsPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${API}/analytics/summary`)
      .then((r) => setData(r.data))
      .catch(() => setError(true));
  }, []);

  const max = data?.days?.length ? Math.max(...data.days.map((d) => d.count)) : 1;

  return (
    <div data-testid="stats-page" className="min-h-screen bg-[#090d16] grain relative">
      <div className="mx-auto max-w-3xl px-5 sm:px-8 py-16 sm:py-24">
        <p className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-green-400 mb-3 flex items-center gap-2">
          <BarChart3 className="w-4 h-4" /> Dold statistik · Studentflyttarna
        </p>
        <h1 className="font-display font-extrabold text-white text-4xl sm:text-5xl tracking-tight">
          Sidvisningar per dag
        </h1>
        <p className="mt-3 text-slate-400 text-sm">
          Helt anonymt – inga IP-adresser, inga cookies, inga personuppgifter. Räknas bara hos besökare som godkänt statistik.
        </p>

        {error && <p className="mt-8 text-slate-400">Kunde inte hämta statistiken just nu.</p>}

        {data && (
          <>
            <div className="mt-10 grid grid-cols-2 gap-4">
              <div data-testid="stats-today" className="rounded-2xl border border-white/10 bg-white/[0.03] p-6">
                <div className="flex items-center gap-2 text-slate-400 text-xs font-mono2 uppercase tracking-[0.2em]">
                  <CalendarDays className="w-4 h-4 text-green-400" /> Idag
                </div>
                <div className="font-display font-extrabold text-white text-5xl mt-3">{data.today}</div>
              </div>
              <div data-testid="stats-total" className="rounded-2xl border border-white/10 bg-white/[0.03] p-6">
                <div className="flex items-center gap-2 text-slate-400 text-xs font-mono2 uppercase tracking-[0.2em]">
                  <Eye className="w-4 h-4 text-green-400" /> Totalt
                </div>
                <div className="font-display font-extrabold text-white text-5xl mt-3">{data.total}</div>
              </div>
            </div>

            <div data-testid="stats-days" className="mt-8 rounded-2xl border border-white/10 bg-white/[0.03] p-6 sm:p-8">
              {data.days.length === 0 && <p className="text-slate-400 text-sm">Ingen statistik ännu.</p>}
              <div className="flex flex-col gap-3.5">
                {data.days.map((d) => (
                  <div key={d.date} data-testid={`stats-day-${d.date}`} className="flex items-center gap-4">
                    <span className="w-28 shrink-0 font-mono2 text-[11px] uppercase tracking-wider text-slate-400">
                      {svDate(d.date)}
                    </span>
                    <div className="flex-1 h-7 rounded-full bg-white/5 overflow-hidden">
                      <div
                        className="h-full rounded-full bg-[#16a34a] transition-[width] duration-700"
                        style={{ width: `${Math.max((d.count / max) * 100, 6)}%` }}
                      />
                    </div>
                    <span className="w-10 text-right font-display font-bold text-white">{d.count}</span>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
